import { createSelector } from 'reselect';
import _ from 'lodash';

const getChains = state => state.businessApp.chains;
const getRestaurants = state => state.businessApp.restaurants;
const getCurrentRestId = state => state.businessApp.restaurantId;
const getCurrentChainId = state => state.businessApp.chainId;

export const getCurrentRestaurant = createSelector(
    [getRestaurants, getCurrentRestId],
    (restaurants, restId) => {
        if (!restId) return null;
        return restaurants.find(rest => rest.id == restId) || { id: restId };
    }
);

export const getCurrentChain = createSelector(
    [getChains, getCurrentChainId],
    (chains, chainId) => {
        if (!chainId) return null;
        return chains.find(rest => rest.id == chainId) || { id: chainId };
    }
);

export const getBusinessesForPicker = createSelector(
    [getRestaurants, getChains],
    (restaurants, chains) => {
        const chainsById = _.keyBy(chains, c => c.id);
        const restByOwners = _.groupBy(restaurants, r => r.ownerId);

        return Object.keys(restByOwners).reduce((businesses, chainId) => {
            const chain = chainsById[chainId];
            if (chain) {
                businesses.push({ id: chain.id, name: chain.name, type: 'chain' });
            }
            return businesses.concat(restByOwners[chainId].map(r => ({ id: r.id, name: r.name, type: 'branch' })));
        }, []);
    }
);

export const getBusinessCurrency = createSelector(
    [getCurrentChain, getCurrentRestaurant, getRestaurants],
    (chain, restaurant, restaurants) => {
        if (restaurant) {
            return restaurant.currencyCode;
        } else if (chain) {
            return (restaurants.find(r => r.ownerId === chain.id) || {}).currencyCode;
        } else {
            return 'ILS';
        }
    }
);
